import React from 'react';
import { oneOfType, string, number } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Directory } from './Directory';

export const DirectoryContainer = ({ timeout, ...props }) => {
  const store = useStore();
  const { storeId, storeZip } = store;

  return (
    <QueryProvider cacheKey="store-directory">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Directory />
    </QueryProvider>
  );
};

DirectoryContainer.propTypes = {
  timeout: oneOfType([string, number])
};

DirectoryContainer.defaultProps = {
  timeout: '3000'
};
